module.exports = __webpack_public_path__ + "img/轮播8.d49c7dce.png";